import { Expose, plainToClassFromExist } from "class-transformer";
import { catApi, catMain } from "@/util/logging";

import { ProduktModel } from "./ProduktModel";
import { api } from "@/util/api";

export class BuchBewegungModel {
  @Expose({ name: "uid" }) uid = "";
  @Expose({ name: "periode" }) periode = "";
  @Expose({ name: "klasse" }) klasse = "";
  @Expose({ name: "bestellung" }) bestellung = 0;
  @Expose({ name: "lieferung" }) lieferung = 0;
  @Expose({ name: "verkauf" }) verkauf = 0;
  @Expose({ name: "remission" }) remission = 0;

  // eslint-disable-next-line
  constructor(plain: Record<string, any>) {
    // console.log("ProduktModel: Creating …", plain);
    plainToClassFromExist(this, plain, { excludeExtraneousValues: true });
    // console.log("ProduktModel: Created: " + JSON.stringify(this, undefined, 2));
  }

  // an array of objects
  public insertInto(array: BuchBewegungModel[]): BuchBewegungModel[] {
    if (array.length === 0) array.push(this);
    else {
      let isLast = true;

      for (let i = 0, len = array.length; i < len; i++) {
        if (this.uid < array[i].uid) {
          isLast = false;
          array.splice(i, 0, this);
          break;
        }
      }
      if (isLast) {
        array.push(this); //add to the end
      }
    }
    return array;
  }

  // ====

  static convert = (data: unknown): BuchBewegungModel[] => {
    const ret = new Array<BuchBewegungModel>();
    if (Array.isArray(data)) {
      data.forEach((element) => {
        const bestand = new BuchBewegungModel(element);
        if (bestand.uid.length > 0) ret.push(bestand);
        else
          catMain.error(
            "Cannot convert value!: " + JSON.stringify(element),
            null
          );
      });
    } else {
      throw new Error("Non-Array in convert method!");
    }
    return ret;
  };

  static PERIODE_TAGE = "tage";
  static PERIODE_WOCHEN = "wochen";
  static PERIODE_MONATE = "monate";
  static PERIODE_QUARTALE = "quartale";
  static PERIODE_JAHRE = "jahre";

  static read = async (
    produkt: ProduktModel,
    filiale: number,
    periode: string
  ): Promise<BuchBewegungModel[]> => {
    if (produkt === null || produkt === undefined || produkt.url == "") {
      catApi.info("  return: [] (because " + produkt + ")");
      return [];
    }
    const url =
      produkt.url + "/bewegungen?filiale=" + filiale + "&periode=" + periode;
    catApi.info("querying: " + url);

    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response = await api.get<BuchBewegungModel[]>("v1" + url);
      catApi.debug("response: /v1" + url + " -> " + JSON.stringify(response));

      return BuchBewegungModel.convert(response.data);
      //
    } catch (e) {
      const err = new Error(JSON.stringify(e));
      catApi.error("caught Error: " + err.message, err);
      return Promise.reject(err);
    }
  };
}
